import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { enviarPreInscricao } from '../assets/js/form';
import '../assets/css/FormRegistration.css';

// Variantes de animação
const formVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
      staggerChildren: 0.1
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const addFieldsVariants = {
  hidden: { opacity: 0, height: 0, marginBottom: 0 },
  visible: { 
    opacity: 1, 
    height: "auto", 
    marginBottom: "1.5rem",
    transition: { 
      duration: 0.5,
      ease: "easeOut"
    } 
  },
  exit: { 
    opacity: 0, 
    height: 0, 
    marginBottom: 0,
    transition: { 
      duration: 0.3,
      ease: "easeIn"
    } 
  }
};

const FormRegistration = () => {
  // Estado do formulário
  const [form, setForm] = useState({
    Nome: '',
    'Data de Nascimento': '',
    turma: '',
    classe: '',
    responsavel: '',
    telefone: '',
    email: '',
    sexo: '',
    especial: '',
    responsavel2: '',
    telefone2: '',
    email2: '',
    irmaos: '',
    irmaosDescricao: '',
    nacEdu1: '',
    dia: '',
    mes: '',
    ano: '',
  });
  const [enviado, setEnviado] = useState(false);
  const [showSecondResponsible, setShowSecondResponsible] = useState(false);

  const opcoesEscola = ["Ensino Primário", "Iº Ciclo", "Infantário"];
  const opcoesBercario = ["Berçário", "1 ano", "2 anos", "3 anos", "4 anos", "5 anos"];
  const opcoesPrimario = ["1ª Classe", "2ª Classe", "3ª Classe", "4ª Classe", "5ª Classe", "6ª Classe"];
  const opcoesSecundario = ["7ª Classe"];
  const opcoesSexo = ["Masculino", "Feminino"];
  const opcoesSimNao = ["Sim", "Não"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newForm = { ...form, [name]: value };
    // Se for data de nascimento, atualizar dia, mes e ano (mas não calcular idade)
    if (name === 'Data de Nascimento') {
      const [ano, mes, dia] = value.split('-');
      newForm.dia = dia || '1';
      newForm.mes = mes || '1';
      newForm.ano = ano || '2025';
    }
    // Se mudar a escola, resetar classe para '-' e vice-versa
    if (name === 'escola') {
      newForm.classe = '-';
    }
    setForm(newForm);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Montar objeto de dados no formato esperado por enviarPreInscricao
    const dados = {
      escola: form.escola || '-',
      idade: form.escola === 'Infantário' ? (form.idade || '-') : '-',
      classe: form.classe || '-',
      nomeAluno: form.Nome || '-',
      dia: form.dia || '-',
      mes: form.mes || '-',
      ano: form.ano || '-',
      sexo: form.sexo || '-',
      especial: form.especial || '-',
      irmaos: form.irmaos || '-',
      irmaosDescricao: form.irmaosDescricao || '-',
      edu1: form.responsavel || '-',
      numEdu1: form.telefone || '-',
      emailEdu1: form.email || '-',
      nacEdu1: form.nacEdu1 || '-',
      edu2: form.responsavel2 || '-',
      numEdu2: form.telefone2 || '-',
      emailEdu2: form.email2 || '-',
      nacEdu2: form.nacEdu2 || '-',
    };
    // Garantir que nenhum valor seja null
    Object.keys(dados).forEach(key => {
      if (dados[key] === null || dados[key] === undefined) {
        dados[key] = '';
      }
    });
    enviarPreInscricao(dados);
    setEnviado(true);
  };

  const toggleSecondResponsible = () => {
    setShowSecondResponsible(!showSecondResponsible);
    
    // Se estiver ocultando os campos, limpar os valores
    if (showSecondResponsible) {
      setForm({
        ...form,
        responsavel2: '',
        telefone2: '',
        email2: '',
        nacEdu2: '' // Limpar nacionalidade do segundo responsável
      });
    }
  };

  if (enviado) {
    return (
        <motion.div
            className="alert alert-success text-center p-4 rounded-4 shadow mx-auto form-success-message"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
        >
          <i className="bi bi-check-circle-fill me-2 fs-3"></i>
          <p className="mb-0 fw-bold">Pré-inscrição enviada com sucesso!</p>
          <p>Em breve entraremos em contato.</p>
        </motion.div>
    );
  }

  return (
      <motion.form
          onSubmit={handleSubmit}
          className="form-registration"
          initial="hidden"
          animate="visible"
          variants={formVariants}
      >
        <motion.h3
            className="form-title"
            variants={itemVariants}
        >
          Formulário de Pré-inscrição
        </motion.h3>

        <motion.div className="mb-4" variants={itemVariants}>
          <div className="row g-3">
            <div className="col-md-8">
              <label className="form-label-custom">Nome do Aluno</label>
              <input
                  type="text"
                  className="form-control"
                  name="Nome"
                  value={form.Nome}
                  onChange={handleChange}
                  required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label-custom">Sexo</label>
              <div className="d-flex gap-3">
                {opcoesSexo.map((sexo) => (
                  <div className="form-check" key={sexo}>
                    <input
                        className="form-check-input"
                        type="radio"
                        name="sexo"
                        id={`sexo-${sexo.toLowerCase()}`}
                        value={sexo}
                        checked={form.sexo === sexo}
                        onChange={handleChange}
                        required
                    />
                    <label className="form-check-label" htmlFor={`sexo-${sexo.toLowerCase()}`}>
                      {sexo}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div className="mb-4" variants={itemVariants}>
          {/* Data de Nascimento em linha isolada */}
          <div className="row g-3">
            <div className="col-12">
              <label className="form-label-custom">Data de Nascimento</label>
              <input
                type="date"
                className="form-control"
                name="Data de Nascimento"
                value={form['Data de Nascimento']}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="row g-3 mt-2">
            <div className="col-md-4">
              <label className="form-label-custom">Escola</label>
              <select
                className="form-select"
                name="escola"
                value={form.escola || ''}
                onChange={handleChange}
                required
              >
                <option value="">Selecione a escola</option>
                {opcoesEscola.map(opcao => (
                  <option key={opcao} value={opcao}>{opcao}</option>
                ))}
              </select>
            </div>
            {form.escola === 'Ensino Primário' && (
              <div className="col-md-4">
                <label className="form-label-custom">Classe</label>
                <select
                  className="form-select"
                  name="classe"
                  value={form.classe}
                  onChange={handleChange}
                  required={form.escola === 'Ensino Primário'}
                >
                  <option value="">Selecione a classe</option>
                  {opcoesPrimario.map(opcao => (
                    <option key={opcao} value={opcao}>{opcao}</option>
                  ))}
                </select>
              </div>
            )}
            {form.escola === 'Iº Ciclo' && (
              <div className="col-md-4">
                <label className="form-label-custom">Classe</label>
                <select
                  className="form-select"
                  name="classe"
                  value={form.classe}
                  onChange={handleChange}
                  required={form.escola === 'Iº Ciclo'}
                >
                  <option value="">Selecione a classe</option>
                  {opcoesSecundario.map(opcao => (
                    <option key={opcao} value={opcao}>{opcao}</option>
                  ))}
                </select>
              </div>
            )}
            {form.escola === 'Infantário' && (
              <div className="col-md-4">
                <label className="form-label-custom">Idade</label>
                <select
                  className="form-select"
                  name="idade"
                  value={form.idade || ''}
                  onChange={handleChange}
                  required={form.escola === 'Infantário'}
                >
                  <option value="">Selecione a idade</option>
                  {opcoesBercario.map(opcao => (
                    <option key={opcao} value={opcao}>{opcao}</option>
                  ))}
                </select>
              </div>
            )}
          </div>
        </motion.div>

        {/* Linha: Necessidades Especiais e Irmãos */}
        <motion.div className="mb-4" variants={itemVariants}>
          {/* Necessidades Educacionais Especiais em linha isolada */}
          <div className="row g-3">
            <div className="col-12">
              <div className="d-flex flex-column align-items-start">
                <label className="form-label-custom mb-2">Necessidades Educacionais Especiais</label>
                <div className="d-flex gap-4">
                  {opcoesSimNao.map((opcao) => (
                    <div className="form-check" key={opcao}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="especial"
                        id={`especial-${opcao.toLowerCase()}`}
                        value={opcao}
                        checked={form.especial === opcao}
                        onChange={handleChange}
                        required
                      />
                      <label className="form-check-label" htmlFor={`especial-${opcao.toLowerCase()}`}>{opcao}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="row g-3 mt-2">
            <div className="col-md-6">
              <label className="form-label-custom">Possui irmão(s) já a estudar na instituição?</label>
              <div className="d-flex gap-4">
                {opcoesSimNao.map((opcao) => (
                  <div className="form-check" key={opcao}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="irmaos"
                      id={`irmaos-${opcao.toLowerCase()}`}
                      value={opcao}
                      checked={form.irmaos === opcao}
                      onChange={handleChange}
                      required
                    />
                    <label className="form-check-label" htmlFor={`irmaos-${opcao.toLowerCase()}`}>{opcao}</label>
                  </div>
                ))}
              </div>
              {form.irmaos === 'Sim' && (
                <div className="mt-2">
                  <label className="form-label-custom">Nome(s) e turma(s) do(s) irmão(s)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="irmaosDescricao"
                    value={form.irmaosDescricao}
                    onChange={handleChange}
                    placeholder="Ex: João - 2ª Classe, Maria - 4 anos"
                    required={form.irmaos === 'Sim'}
                  />
                </div>
              )}
            </div>
          </div>
        </motion.div>

        {/* Seção de Responsável Principal */}
        <div className="form-section">
          <motion.h5 
            className="section-title-f"
            variants={itemVariants}
          >
            Responsável Principal
          </motion.h5>

          <motion.div className="mb-4" variants={itemVariants}>
            <label className="form-label-custom">Nome</label>
            <input
                type="text"
                className="form-control"
                name="responsavel"
                value={form.responsavel}
                onChange={handleChange}
                required
            />
          </motion.div>
          <motion.div className="mb-4" variants={itemVariants}>
            <label className="form-label-custom">Nacionalidade</label>
            <input
              type="text"
              className="form-control"
              name="nacEdu1"
              value={form.nacEdu1}
              onChange={handleChange}
              required
            />
          </motion.div>

          <motion.div className="mb-4" variants={itemVariants}>
            <label className="form-label-custom">Telefone</label>
            <div className="input-group">
              <span className="input-group-text"><i className="bi bi-telephone-fill"></i></span>
              <input
                  type="tel"
                  className="form-control"
                  name="telefone"
                  value={form.telefone}
                  onChange={handleChange}
                  placeholder="+244 XXX XXX XXX"
                  required
              />
            </div>
          </motion.div>

          <motion.div className="mb-4" variants={itemVariants}>
            <label className="form-label-custom">Email</label>
            <div className="input-group">
              <span className="input-group-text"><i className="bi bi-envelope-fill"></i></span>
              <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="exemplo@email.com"
                  required
              />
            </div>
          </motion.div>
        </div>

        {/* Botão para adicionar segundo responsável */}
        <motion.div className="d-flex justify-content-center mb-4" variants={itemVariants}>
          <motion.button
            type="button"
            className="btn btn-outline-primary rounded-pill py-2 px-4"
            onClick={toggleSecondResponsible}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <i className={`bi bi-${showSecondResponsible ? 'dash-circle' : 'plus-circle'} me-2`}></i>
            {showSecondResponsible ? 'Remover Segundo Responsável' : 'Adicionar Segundo Responsável'}
          </motion.button>
        </motion.div>

        {/* Campos do segundo responsável (condicionais) */}
        <AnimatePresence>
          {showSecondResponsible && (
            <motion.div 
              className="second-responsible-section" 
              variants={addFieldsVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              <motion.h5 
                className="section-title-f"
              >
                Segundo Responsável
              </motion.h5>

              <div className="mb-4">
                <label className="form-label-custom">Nome</label>
                <input
                    type="text"
                    className="form-control"
                    name="responsavel2"
                    value={form.responsavel2}
                    onChange={handleChange}
                    required
                />
              </div>
              <div className="mb-4">
                <label className="form-label-custom">Nacionalidade</label>
                <input
                  type="text"
                  className="form-control"
                  name="nacEdu2"
                  value={form.nacEdu2 || ''}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-4">
                <label className="form-label-custom">Telefone</label>
                <div className="input-group">
                  <span className="input-group-text"><i className="bi bi-telephone-fill"></i></span>
                  <input
                      type="tel"
                      className="form-control"
                      name="telefone2"
                      value={form.telefone2}
                      onChange={handleChange}
                      placeholder="+244 XXX XXX XXX"
                      required
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label-custom">Email</label>
                <div className="input-group">
                  <span className="input-group-text"><i className="bi bi-envelope-fill"></i></span>
                  <input
                      type="email"
                      className="form-control"
                      name="email2"
                      value={form.email2}
                      onChange={handleChange}
                      placeholder="exemplo@email.com"
                      required
                  />
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        <motion.div
            className="d-flex justify-content-center mt-4"
            variants={itemVariants}
        >
          <motion.button
              type="submit"
              className="submit-button"
              whileHover={{
                scale: 1.05,
                boxShadow: '0 6px 20px rgba(52, 152, 219, 0.4)',
                y: -3
              }}
              whileTap={{ scale: 0.95 }}
          >
            <i className="bi bi-send-fill me-2"></i>
            Enviar Pré-inscrição
          </motion.button>
        </motion.div>
      </motion.form>
  );
};

export default FormRegistration;